import { Component, Input } from '@angular/core';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { TooltipDirective, ValidateInnerDirective, IconComponent } from '@skylab-angular-shared/ui';


@Component({
    selector: 'skl-document-item-inventory-level-cell',
    template: `
        @if (!isHidden) {
            <div
                class="icon-color display--flex-column display--flex-column__center"
                [sklValidateInner]="{key: quantitySun, option: 'disable'}" [sklValidateInnerReadonly]="isDisabled">
                <skl-icon
                    [tooltip]="'scenes.shared.grid.ui.document-item-inventory-level-cell.tooltip' | translate"
                    size="18px"
                    name="availability-status">
                </skl-icon>
            </div>
        }
    `,
    styles: [`
        .icon-color {
            color: var(--text-minor-color)
        }
        .icon-disabled {
            opacity: var(--disabled-opacity, 0.3)
        }
    `],
    imports: [ValidateInnerDirective, TooltipDirective, TranslatePipe, IconComponent]
})
export class DocumentItemInventoryLevelCellComponent {
    @Input() public isHidden = false;
    @Input() public isDisabled!: boolean;
    @Input() public quantitySun!: string;
}
